import Flex from "common/Boxes/Flex";
import {
  useOnboardingAnalytics,
  useOnboardingStepView,
} from "analytics/onboarding";
import SelectExchange from "features/portfolio/CreateAccount/SelectExchange";
import LoadingSpinnerOverlay from "common/Overlays/LoadingSpinnerOverlay";
import { useContext } from "react";
import IntentWelcome from "features/onboarding/guided/IntentWelcome";
import { useHistory, useLocation } from "react-router-dom";
import { OnboardingBackLink } from "features/onboarding/common/BackButton";
import { BackArrow } from "features/onboarding/common/OnboardingIcons";
import { QuickConnectContext } from "@shared/features/onboarding/QuickConnect.context";
import useQuery from "utils/hooks/useQuery";
import {
  QUICK_CONNECT_CONN_CODE_QUERY_PARAM,
  QUICK_CONNECT_STATE_QUERY_PARAM,
} from "features/configuration/common/constants.ts";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";
import { LanguageNameSpaces } from "@shared/types";
import { ExternalConnectAccountContext } from "@shared/features/configuration/ExternalConnectAccount.context";

interface OnboardingSelectExchangeProps {
  onSelectExchange: (primaryExchange: string) => void;
}
const OnboardingSelectExchange = ({
  onSelectExchange,
}: OnboardingSelectExchangeProps) => {
  const { quickConnectLoading, code, state } =
    useContext(QuickConnectContext) || {};
  const { isExternalConnectAccount } =
    useContext(ExternalConnectAccountContext) || {};
  const query = useQuery();
  const showExchanges = query.get("connectLive") === "1";
  const history = useHistory();
  const location = useLocation();
  const track = useOnboardingAnalytics();
  const returnToChoices = () => {
    track("Back Clicked", { from_step: "exchange_selection" });
    const nextQuery = new URLSearchParams(location.search);
    nextQuery.delete("customDemo");
    nextQuery.delete("connectLive");
    history.replace({ ...location, search: nextQuery.toString() });
  };
  const { t } = useTypedTranslation(LanguageNameSpaces.ONBOARDING);
  const isQuickConnect =
    (!!query.get(QUICK_CONNECT_STATE_QUERY_PARAM) &&
      !!query.get(QUICK_CONNECT_CONN_CODE_QUERY_PARAM)) ||
    (!!code && !!state);
  useOnboardingStepView(
    !isExternalConnectAccount && showExchanges && !isQuickConnect
      ? "exchange_selection"
      : undefined
  );
  if (
    !isExternalConnectAccount &&
    !showExchanges &&
    !isQuickConnect &&
    query.get("customDemo") !== "1"
  ) {
    return <IntentWelcome />;
  }
  return (
    <Flex $flexDirection="column" style={{ width: "100%", maxWidth: 1040 }}>
      <LoadingSpinnerOverlay
        isLoading={quickConnectLoading || isQuickConnect}
        hideContentWhileLoading={true}
        spinnerSize="large"
        wrap={true}
        wrapStyle={{ width: "100%", minHeight: 200 }}
      >
        {!isQuickConnect && !isExternalConnectAccount && (
          <OnboardingBackLink type="button" onClick={returnToChoices}>
            <BackArrow />
            {t(
              query.get("startMode") === "1"
                ? "intent.mode_back"
                : "intent.change_method"
            )}
          </OnboardingBackLink>
        )}
        <SelectExchange
          isOnboarding={true}
          onSelectExchange={(exchange) => {
            track("Exchange Selected", { exchange });
            onSelectExchange(exchange);
          }}
          showDemoAccountOption={false}
        />
      </LoadingSpinnerOverlay>
    </Flex>
  );
};
export default OnboardingSelectExchange;
